<template>
  <v-menu
    :nudge-bottom="5"
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-center">
        <v-icon
          :color="highlightColor"
          size="24"
          v-bind="attrs"
          v-on="on">
          $slider
        </v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in sortItems"
        :key="item.request + index"
        :class="{'v-item--active v-list-item--active': item.dataTest === defaultItem.dataTest }"
        @click="$emit('resort', item)">
        <v-list-item-title class="pointer">
          {{ item.name }}
          <v-icon
            v-if="item.arrowIcon"
            color="black"
            x-small>
            {{ item.arrowIcon }}
          </v-icon>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AppSortV2',
  props: {
    defaultItem: {
      type: Object,
      default: null,
    },
    highlightColor: {
      type: String,
      default: 'black',
    },
    sortItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
